import { clearActiveUser, signOut } from '@hermes/api-sdk'
import { useCallback } from 'react'
import { useUserToken } from './useUserToken'

export const useSignOut = () => {
  const { token, deleteAllTokens } = useUserToken()

  const signOutAction = useCallback(() => {
    if (!token) {
      deleteAllTokens()
      clearActiveUser()
      return
    }
    signOut({ token }).catch((error) => {
      console.error('Error signing out:', error)
    })
    deleteAllTokens()
    clearActiveUser()
  }, [token])

  return { signOut: signOutAction }
}
